import { styled } from '@acko-tech/building-blocks.ui.common';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    box-sizing: border-box;
    border: 3px solid #e7e7f0;
    border-radius: 8px;
    padding: 0px 16px 16px;
    margin-top: 16px;

    position: relative;
`;

export const Label = styled.p`
    width: max-content;
    padding: 2px 4px;
    font-size: 12px;
    color: #5b5675;
    position: absolute;
    top: 0px;
    left: 0px;
    transform: translate(0.8em, -22px);
    background: white;
    display: inline-block;
`;
